;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.dashboard', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var dashboardState = {
      name: 'dashboard',
      params: {
        current: null
      },
      url: '/{current:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: {
        dashboards: [ 'SessionService', 'DashboardManager', function (SessionService, DashboardManager) {
          return SessionService.isLoaded().then(function () {
            var user = SessionService.getUser()
            var roles = SessionService.getRoles()
            return DashboardManager.get(
              DashboardManager
              .query({
                populate: JSON.stringify([
                  {
                    path: 'cards'
                  }
                ])
              })).then(
                function (data) {
                  /** If the user has no dashboard, create it, save it, and return it */
                  if (data.data.length === 0) {
                    var dashboard = DashboardManager.create()
                    dashboard.label = 'Nouveau Tableau de Bord'
                    return dashboard.save().then(function (saved) {
                      return [ dashboard ]
                    })
                  } else {
                    return _.map(data.data, function (dashboard) {
                      if (_.get(dashboard, 'options.shared')) {
                        dashboard.shared = true
                      }
                      dashboard.editable = _.includes(roles, 'admin') || dashboard.user === user
                      return dashboard
                    })
                  }
                })
          })
        } ],
        currentDashboard: [ 'dashboards', '$stateParams', 'PreferencesService', function (dashboards, $stateParams, PreferencesService) {
          if ($stateParams.current) {
            return _.find(dashboards, { _id: $stateParams.current }) || dashboards[ 0 ]
          } else {
            return PreferencesService.getGeneralPrefs().then(function (pref) {
              return _.find(dashboards, {_id: _.get(pref, 'settings.dashboard.default')}) || dashboards[0]
            })
          }
        } ],
        prefs: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getGeneralPrefs().then(function (prefs) {
            return prefs
          })
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/dashboard/dashboard.template.html',
          controller: 'DashboardController',
          controllerAs: 'dashboard'
        },
        'toolbar@': {
          templateUrl: '/app/modules/dashboard/dashboard-toolbar.template.html',
          controller: 'DashboardToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{toolbar.current.label}}'
      }
    }

    $stateProvider.state(dashboardState)
  }
})(window.angular, window._)
